export function buildAutomationUpdateRequest(automation, text) {
  return {
    automationId: automation?.id,
    automationName: automation?.nome,
    requestText: text.trim(),
  };
}

export function buildSuggestedAutomationRequest(automation, notes) {
  return {
    automationId: automation?.id,
    automationName: automation?.nome,
    notes: notes.trim(),
  };
}

export function buildCustomAutomationRequest(request) {
  return {
    ...request,
    descrizione: request.descrizione.trim(),
    funzionalita: request.funzionalita.trim(),
    obiettivo: request.obiettivo.trim(),
  };
}
